import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { PatchOrganisation } from 'src/types/shared/Organisation';

export const patchOrganisationRequest = createAction('patchOrganisationRequest');
export const patchOrganisationSuccess = createAction<PatchOrganisation>('patchOrganisationSuccess');
export const patchOrganisationFailure = createAction('patchOrganisationFailure');

export const patchOrganisation = (organisation: PatchOrganisation, id: number) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(patchOrganisationRequest());
    try {
        const { data }: Response = await api.patch(
            `admin/challengeApplications/${id}`,
            organisation,
        );

        dispatch(patchOrganisationSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, patchOrganisationFailure, e as any);
    }
};

export interface Response {
    data: PatchOrganisation;
}
